import React, { useState } from "react";
import Slider from "react-slick";
import { Chart } from "primereact/chart";
import { Divider } from "primereact/divider";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Spinner from "../../components/spinner";
import { Calendar } from "primereact/calendar";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

const KioskCard = ({ kiosk, loading }) => {
  const pieData = {
    labels: ["Schedule Visit", "Need Base Visit"],
    datasets: [
      {
        data: [kiosk?.visitsScheduled || "--", kiosk?.visitsNeedBased || "--"],
        backgroundColor: ["#E98440", "#659FD3"],
      },
    ],
  };

  const pieOptions = {
    maintainAspectRatio: false,
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        bodyFont: {
          size: 10,
        },
      },
    },
  };

  const data = ["available", "printed", "balance"].map((key) => ({
    type: key.charAt(0).toUpperCase() + key.slice(1),
    creditCard: kiosk?.creditCard?.[key] || "--",
    debitCard: kiosk?.debitCard?.[key] || "--",
  }));

  return (
    <div className="p-2">
      <div className="card h-full flex flex-col">
        <h3 className="text-lg font-semibold mb-2">{kiosk?.kioskId || "--"}</h3>

        <div className="p-2 alerts-boxes">
          <div className="d-flex transactions-section">
            <div>
              <span className="top-h">Transactions</span>

              <p className="text-1xl font-bold mt-2 text-cyan-700">
                {`${kiosk?.transactions || "--"} PKR`}
              </p>
            </div>
            <div>
              <span className="top-h">Alert</span>

              <p className="text-1xl font-bold mt-2 text-cyan-700">
                {kiosk?.alerts || "--"}
              </p>
            </div>
          </div>
        </div>
        <Divider />
        <div className="p-2 mb-2 alerts-boxes-cards">
          <div className="card-containers">
            <DataTable value={data} scrollable className="custom-table">
              <Column field="type" header="" frozen></Column>
              <Column field="debitCard" header="Debit Card"></Column>
              {/* <Column field="creditCard" header="Credit Card"></Column> */}
            </DataTable>
          </div>
        </div>

        <div className="text-sm font-medium">
          <Divider />
          <h3 className="text-lg font-semibold mb-0 mt-1">Visit Overview</h3>
          <div className="d-flex justify-content-between align-items-center">
            <span className="text-3xl font-bold mt-2 text-cyan-700">
              {kiosk?.visitsScheduled || "--"}
            </span>
            <span className="text-3xl font-bold mt-2 text-cyan-700">
              {kiosk?.visitsNeedBased || "--"}
            </span>
          </div>
          <div className="d-flex justify-content-between align-items-center text-sm">
            <span style={{ fontSize: "10px" }}>Schedule Visit</span>
            <span style={{ fontSize: "10px" }}>Need Base Visit</span>
          </div>
          <div className="mt-2">
            <Chart
              type="pie"
              data={pieData}
              options={pieOptions}
              style={{ maxWidth: "150px", maxHeight: "150px", margin: "auto" }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const StatsOverViewComponent = ({ dashboardStatsData, loading, setOverviewDate, overviewDate }) => {

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1460,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div className="stats-overview">
      <div className="d-flex justify-content-between align-items-center mb-2 mt-4">
        <h3 className="text-xl font-bold mb-0">KIOSK Status Overview</h3>
        <Calendar
          value={overviewDate}
          onChange={(e) => setOverviewDate(e.value)}
          showIcon
        />
      </div>
      <Slider {...settings}>
        {(dashboardStatsData || []).map((kiosk, index) => (
          <KioskCard key={index} kiosk={kiosk} loading={loading} />
        ))}
      </Slider>
    </div>
  );
};

export default StatsOverViewComponent;
